export function getStatusName(val) {
  switch (val) {
    case "TicketCancelationRequested":
      return "Awaiting Cancellation";
    case "PendingVoid":
      return "Awaiting Void";
    default:
      return getGeneralStatus(val);
  }
}

export function getChangeStatusName(val, data) {
  if (data?.status === "Approved" && data?.changePrice && !data?.isConfirmed)
    return "Awaiting Payment By Agent";
  if (data?.status === "Paid") return "Awaiting Submission to Airline";

  switch (val) {
    case "Pending":
      return "Awaiting Assignment";
    default:
      return getGeneralStatus(val);
  }
}
export function getRefundStatusName(val, data) {
  if (data?.status === "Approved" && !data?.priceReceived && !data?.confirmed)
    return "Awaiting Quote by Admin";
  if (data?.status === "Approved" && data?.priceReceived && !data?.confirmed)
    return "Awaiting Agent Confirmation";
  if (data?.status === "Approved" && data?.priceReceived && data?.confirmed)
    return "Awaiting Submission to Airline";
  if (
    data?.status === "PendingRefund" &&
    data?.priceReceived &&
    data?.confirmed
  )
    return "Awaiting Re-Imbursement";

  switch (val) {
    case "Pending":
      return "Awaiting Assignment";
    default:
      return getGeneralStatus(val);
  }
}

export function getGeneralStatus(status) {
  switch (status) {
    case "PendingChange":
    case "PendingVoid":
    case "PendingRefund":
    case "PendingReissue":
      return "Pending change from airline";
    case "Approved":
    case "Pending":
      return "Under Review by Admin";
    case "PendingPayment":
      return "Awaiting Payment";
    case "ChangedOrder":
      return "Reissued";
    case "Paid":
      //   return "Processing";
      return "Paid";
    case "Success":
      return "Completed";
    case "Rejected":
    case "Denied":
      return "Rejected";
    case "Failed":
      return "Failed";
    case "Closed":
      return "Closed";
    default:
      return status;
  }
}

//   Approved = "Approved",
//   Paid = "Paid",
//   Denied = "Denied",
//   Pending = "Pending",
//   PendingPayment = "PendingPayment",
//   PendingVoid = "PendingVoid",
//   PendingRefund = "PendingRefund",
//   Success = "Success",
//   Failed = "Failed",
//   Closed = "Closed",
//   Canceled = "Canceled",
//   AwaitingAdmin = "AwaitingAdmin"
